// VzmTextareaField.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import React, { useState } from "react";
import { TextField } from "@mui/material";
import { AppWord, InputType } from "../value/AppConst";
import IsValid from "../value/IsValid";

export default function VzmTextareaField({
    dict,
    value,
    disabled,
    onChange,
    onFocused,
    fullWidth,
}) {
    const [error, setError] = useState(false);
    
    const onChangeValue = (e) => {
        const value = e.target.value;
        let error = false;
        if(dict.check) {
            error = !dict.check(value);
            setError(error);
        }
        else if(dict.max) {
            error = !IsValid.string(value, dict.min ? dict.min : dict.required ? 1 : 0, dict.max);
            setError(error);
        }
        onChange(dict.id, value, error);
    };

    const fieldInputProps = dict.inputPropsStyle ? {style:dict.inputPropsStyle} : undefined;

    return(
        <TextField id={dict.id} size={AppWord.SMALL}
            inputProps={fieldInputProps}
            fullWidth={fullWidth}
            type={InputType.text}
            label={dict.label}
            required={dict.required}
            value={value || ''}
            error={error}
            multiline
            rows={dict.rows ? dict.rows : 4}
            placeholder={dict.placeholder ? dict.placeholder : undefined}
            helperText={dict.errorHelp ? dict.errorHelp : undefined}
            onChange={onChangeValue}
            onFocus={()=>{if(onFocused) onFocused(dict)}}
            disabled={disabled?true:false}
            />
    );
}